module.exports = __webpack_public_path__ + "img/imageHA.ab5c24cf.png";